module.exports = __webpack_public_path__ + "942c5562c815723f6f1e9763632645e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_60.jpg
// module id = 1718
// module chunks = 5